var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.999,
    height: 61.756,
    viewBox: "0 0 92.999 61.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_icon",
    transform: "translate(-645.501 -316.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6704",
    "data-name": "Path 6704",
    d: "M6229.732-710.518a2.127,2.127,0,0,1-.372-.03,17.894,17.894,0,0,1-12.271-5.625A18.309,18.309,0,0,1,6212-728.842a18.372,18.372,0,0,1,4.853-12.466,17.966,17.966,0,0,1,11.535-5.777,26.545,26.545,0,0,1,9.546-12.189A26.078,26.078,0,0,1,6252.952-764a26.083,26.083,0,0,1,15.018,4.727,26.52,26.52,0,0,1,9.545,12.189,17.948,17.948,0,0,1,7.825,2.661,18.3,18.3,0,0,1,5.853,5.953A13.907,13.907,0,0,1,6305-724.5a14.01,14.01,0,0,1-3.69,9.511,13.694,13.694,0,0,1-9.051,4.41,2.235,2.235,0,0,1-.489.055h-15.311a2.313,2.313,0,0,1-2.3-2.321,2.313,2.313,0,0,1,2.3-2.321H6291.4c.076-.011.15-.019.237-.025h.006a9.255,9.255,0,0,0,8.755-9.306,9.284,9.284,0,0,0-9.21-9.334,8.768,8.768,0,0,0-1.042.068,2.476,2.476,0,0,1-.264.014,2.307,2.307,0,0,1-2.049-1.271l0,0a13.429,13.429,0,0,0-11.975-7.5,2.292,2.292,0,0,1-2.174-1.6,21.786,21.786,0,0,0-20.732-15.233,21.783,21.783,0,0,0-20.731,15.233,2.3,2.3,0,0,1-2.178,1.6,13.622,13.622,0,0,0-13.445,13.681,13.667,13.667,0,0,0,13.188,13.66,2.169,2.169,0,0,1,.246.022h10.5a2.313,2.313,0,0,1,2.3,2.323,2.313,2.313,0,0,1-2.3,2.321Z",
    transform: "translate(-5566.5 1080.5)",
    fill: "#bdc0c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6705",
    "data-name": "Path 6705",
    d: "M6227.87-745.274l-6.353-6.437-6.349,6.437a1.836,1.836,0,0,1-1.315.549,1.833,1.833,0,0,1-1.313-.549,1.893,1.893,0,0,1,0-2.644l6.361-6.445-6.361-6.443a1.887,1.887,0,0,1,0-2.643,1.838,1.838,0,0,1,1.315-.55,1.837,1.837,0,0,1,1.313.55l6.349,6.435,6.353-6.435a1.838,1.838,0,0,1,1.315-.55,1.83,1.83,0,0,1,1.312.55,1.886,1.886,0,0,1,0,2.644l-6.36,6.441,6.36,6.445a1.889,1.889,0,0,1,0,2.644,1.831,1.831,0,0,1-1.313.549A1.834,1.834,0,0,1,6227.87-745.274Z",
    transform: "translate(-5529.52 1122.982)",
    fill: "#f05555"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud_icon.d8191e45.svg";
export { ForwardRef as ReactComponent };